<template>
  <div class="field-wrapper field-wrapper--text"
       :class="[field.cssClass, {'visually-hidden': field.visibility === 'hidden'}, 'field-wrapper--' + field.size]">
    <div class="field-group field-group--block"
         :class="[{'field-group--is-error': isError}]">
      <label
        class="label"
        :for="'input_' + formId + '_' + field.id"
        :class="[{'visually-hidden': field.labelPlacement === 'hidden_label'}]"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </label>
      <template v-if="field.inputMaskValue">
        <input :id="'input_' + formId + '_' + field.id"
               :name="'input_' + field.id"
               v-model="text"
               @focus="inputFocus"
               @blur="inputBlur"
               v-mask="field.inputMaskValue.replace(/9/g, '#')"
               :required="field.isRequired"
               :placeholder="field.labelPlacement === 'hidden_label' ? field.placeholder : null"
               type="text">
      </template>
      <template v-else>
        <input :id="'input_' + formId + '_' + field.id"
               :name="'input_' + field.id"
               v-model="text"
               @focus="inputFocus"
               @blur="inputBlur"
               :autocomplete="isFieldAutocompletePossible(field.adminLabel)"
               :required="field.isRequired"
               :placeholder="field.labelPlacement === 'hidden_label' ? field.placeholder : null"
               type="text">
      </template>
    </div>

    <slot name="description"></slot>
    <slot name="error"></slot>
  </div>
</template>

<script>
import store from '../store';
import VFieldMixins from './VFieldMixins.vue';
export default {
  store,
  name: "VFieldText",
  mixins: [VFieldMixins],
  data () {
    return {
      text: '',
    }
  },

  mounted() {
    const url_string = window.location.href
    const url = new URL(url_string);

    if (this.field.adminLabel === "Angebot ID") {
      this.text = this.vehicleId
    } else if (this.field.adminLabel === "Kurs ID") {
      const courseId = url.searchParams.get("url");
      this.text = courseId
    } else if (this.field.adminLabel === "Kurs Ort") {
      const location = url.searchParams.get("course_location");
      this.text = location
    } else if (this.field.adminLabel === "Link") {
      this.text = window.location.href
    }
  },

  methods: {
    isFieldAutocompletePossible (adminLabel) {
      return ["Angebote ID", "Kurs ID", "Kurs Ort", "Link"].includes(adminLabel) ? "nope" : "on"
    }
  },

  props: {
    formId: Number,
    field: Object,
    fieldKey: Number,
    isError: String,
    vehicleId: Number,
    courseId: Number
  },
  watch: {
    text: {
      immediate: true,
      deep: false,
      handler (newValue) {
        store.commit(
            'UPDATE_USER_FORM_DATA' ,
            {'key': this.field.id, 'value': newValue})
      }
    }
  }

}
</script>
